import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import CustomRadio from '../../../../../components/mazraeKit/customRadio';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../../../components/SpinnerLoading';
import useGetCooperationAgreementStatus from '../../../../../services/hookService/getCooperationAgreementStatus/useGetCooperationAgreementStatus';
import {IPersonalityType} from '../../../../../services/hookService/getUserCooperationAgreementData/types';
import useGetUserCooperationAgreementData from '../../../../../services/hookService/getUserCooperationAgreementData/useGetUserCooperationAgreementData';
import EditableFormList from './components/EditableFormList';
import {ContractStatusEnum} from './components/SignStatusBadge';

const MyStoreSalesPartnershipAgreement = () => {
  const [userType, setUserType] = useState<IPersonalityType | null>(null);

  const navigate = useNavigate();

  const {data, isLoading} = useGetUserCooperationAgreementData({});

  const {contractStatus} = useGetCooperationAgreementStatus();

  useEffect(() => {
    if (!contractStatus) return;

    if (contractStatus === ContractStatusEnum.NotCompleted) {
      navigate('/my-store-info');
    }
  }, [contractStatus]);

  return (
    <main className="relative flex flex-col bg-white h-dvh">
      <CustomHeader
        title={' قرارداد مشارکت در فروش '}
        preIcon="icon-nameArrow---Right ml-2"
        isActiveRightIcon
        justifyFlex="justify-start"
        sticky
      />

      <div className="flex-1 h-full overflow-y-auto">
        <div className="flex flex-col min-h-full gap-1 p-6">
          <section>
            <article>
              <h4 className="text-sm font-medium text-zinc-500">
                قرارداد بین سامانه مزرعه و فروشگاه
              </h4>
              <span className="block mt-2 text-sm text-gray-600">
                بعد از ثبت فروشگاه، با امضای قرارداد مشارکت در فروش می‌توانید
                فروش نقدی یا اعتباری در سامانه مزرعه داشته باشید. بعد از دانلود
                و مطالعه مفاد قرارداد، آن را بصورت دیجیتال امضا کنید.
              </span>
            </article>

            <div className="flex flex-col space-y-2">
              <h6 className="block mt-3 text-sm font-medium text-zinc-500">
                نوع کاربر <span className="text-red-700">*</span>
              </h6>

              <div className="space-y-4">
                <CustomRadio
                  customClassName="text-gray-700 text-sm w-full h-full"
                  title="کاربر حقیقی"
                  name="userType"
                  value=""
                  checked={userType === IPersonalityType?.Individual}
                  onChange={() => setUserType(IPersonalityType?.Individual)}
                />

                <CustomRadio
                  customClassName="text-gray-700 text-sm w-full h-full"
                  title="کاربر حقوقی"
                  name="userType"
                  value=""
                  checked={userType === IPersonalityType?.Corporate}
                  onChange={() => setUserType(IPersonalityType?.Corporate)}
                />
              </div>
            </div>
          </section>

          {userType && isLoading && (
            <div className="flex items-center justify-center w-full mt-10 ">
              <SpinnerLoading />
            </div>
          )}

          <div className="flex-1" />

          <section>
            <EditableFormList
              formData={data}
              userType={userType!}
              showForm={!!userType && !isLoading}
            />
          </section>
        </div>
      </div>
    </main>
  );
};

export default MyStoreSalesPartnershipAgreement;
